export default function () {
  // ── 1. Discover sections ───────────────────────────────────────────────────
  const sections = [
    ...document.querySelectorAll(".view-height-text-block"),
  ].filter((section) => section.hasAttribute("nav-item-name"));

  if (sections.length === 0) return;

  const firstSection = sections[0];
  const footer = document.querySelector("footer");

  // ── 2. Inject nav before first section ────────────────────────────────────
  const nav = document.createElement("div");
  nav.className = "floating-nav";
  nav.id = "floatingNav";
  nav.setAttribute("aria-label", "Section navigation");
  nav.innerHTML = `<ul role="list"></ul>`;
  firstSection.insertAdjacentElement("beforebegin", nav);

  const ul = nav.querySelector("ul");

  // ── 3. Build nav items ─────────────────────────────────────────────────────
  sections.forEach((section, i) => {
    const index = i + 1;
    const label =
      section.getAttribute("nav-item-name")?.trim() || `Section ${index}`;

    if (!section.id) {
      section.id = `vhtb-section-${index}`;
    }

    const li = document.createElement("li");
    li.dataset.target = section.id;

    const a = document.createElement("a");
    a.href = `#${section.id}`;
    a.textContent = label;
    a.classList.add("floating-nav__link");

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "6");
    svg.setAttribute("height", "6");
    svg.setAttribute("viewBox", "0 0 6 6");
    svg.setAttribute("fill", "none");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svg.setAttribute("aria-hidden", "true");
    svg.innerHTML = `<path d="M-9.76324e-05 2.59991C-9.76324e-05 1.17991 1.1599 -8.84533e-05 2.5799 -8.84533e-05C4.0199 -8.84533e-05 5.1799 1.17991 5.1799 2.59991C5.1799 4.03991 4.0199 5.19991 2.5799 5.19991C1.1599 5.19991 -9.76324e-05 4.03991 -9.76324e-05 2.59991Z" fill="#FF5054"/>`;

    li.appendChild(a);
    li.appendChild(svg);
    ul.appendChild(li);
  });

  const links = ul.querySelectorAll(".floating-nav__link");

  // ── 4. Active link helper ──────────────────────────────────────────────────
  function setActiveLink(id) {
    links.forEach((link) => {
      link.classList.remove("active");
    });
    if (id) {
      const activeLink = [...links].find((link) =>
        link.href.endsWith(`#${id}`),
      );
      if (activeLink) activeLink.classList.add("active");
    }
  }

  // ── 5. Sticky logic ────────────────────────────────────────────────────────
  // Before first section → sticky (sits in normal flow, top: 126px)
  // Once first section reached → fixed at bottom: 40px for rest of page
  // Scroll back above first section → back to sticky

  function updateNav() {
    const firstRect = firstSection.getBoundingClientRect();

    if (firstRect.top <= window.innerHeight) {
      // First section is in or past the viewport — fix to bottom
      nav.classList.add("is-fixed-bottom");
    } else {
      // Above first section — back to sticky
      nav.classList.remove("is-fixed-bottom");
    }
  }

  // ── 6. Smooth scroll on click ──────────────────────────────────────────────
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const id = link.href.split("#")[1];
      const target = document.getElementById(id);
      if (!target) return;

      target.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveLink(id);
      link.blur();

      setTimeout(() => {
        links.forEach((l) => l.classList.remove("active"));
      }, 800);

      history.replaceState(
        null,
        "",
        `${location.pathname}${location.search}#${id}`,
      );
    });
  });

  // ── 7. Scroll spy ──────────────────────────────────────────────────────────
  const scrollSpyObserver = new IntersectionObserver(
    (entries) => {
      const entering = entries.filter((e) => e.isIntersecting);
      if (entering.length === 0) return;

      const topmost = entering.sort(
        (a, b) => a.boundingClientRect.top - b.boundingClientRect.top,
      )[0];

      setActiveLink(topmost.target.id);
    },
    {
      threshold: 0,
      rootMargin: "-20% 0px -60% 0px",
    },
  );

  sections.forEach((s) => scrollSpyObserver.observe(s));

  // ── 8. Scroll + resize ─────────────────────────────────────────────────────
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateNav();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", updateNav, { passive: true });

  updateNav();
}
